import { render, staticRenderFns } from "./SketchDescription.vue?vue&type=template&id=2359ff1b"
import script from "./SketchDescription.vue?vue&type=script&lang=js"
export * from "./SketchDescription.vue?vue&type=script&lang=js"
import style0 from "./SketchDescription.vue?vue&type=style&index=0&id=2359ff1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports